<template>
  <SectionSplit
    class="Meeting2026Link"
    src="../../assets/landing-finances/meeting-2026-link.jpg">
    <h3>
      {{ $t("title") }}
    </h3>
    <p
      v-for="(paragraph, index) in $t('paragraphs')"
      :key="index"
      v-html="paragraph" />
  </SectionSplit>
</template>

<script>
import SectionSplit from 'views/components/SectionSplit'

export default {
  components: { SectionSplit },
}
</script>

<style lang="scss">
.Meeting2026Link {
  .Splitter-body {
    max-width: 50rem;
  }

  .body {
    padding: 2rem 0;
  }
}
</style>

<i18n>
{
  "en": {
    "title": "Due to access to the remote meeting of bondholders of Sun Investment Group, UAB",
    "paragraphs": [
      "Dear investors,<br><br>We provide the notice on the access link to the meeting of bondholders&#39; of Sun Investment Group, UAB that will be held remotely via Zoom platform on May 20, 2026.<br><br><a href=\"https://us06web.zoom.us/j/82706444217?pwd=qhb0eJoUC1b3ZJMvYrDOY2dqzMGFsl.1\" target=\"_blank\">Direct link to the remote meeting is here</a> or going through <a href=\"https://zoom.us/join\" target=\"_blank\">https://zoom.us/join</a>.<br>Meeting <b>ID: 827 0644 4217</b><br><b>Passcode: UpU40D</b><br><br>Detailed information about the meeting and related documents were announced in the notice published on April 24, 2026 (<a href=\"https://view.news.eu.nasdaq.com/view?id=1436879&lang=en\" target=\"_blank\">Due to the convened meeting of bondholders of Sun Investment Group, UAB</a>).<br><br>Nasdaq link: <a href=\"https://view.news.eu.nasdaq.com/view?id=1439599&lang=en\" target=\"_blank\">Due to access to the remote meeting of bondholders of Sun Investment Group, UAB</a>"
    ]
  },
  "lt": {
    "title": "Dėl prisijungimo nuorodos į nuotolinį Sun Investment Group, UAB obligacijų savininkų susirinkimą",
    "paragraphs": [
      "Gerbiami investuotojai,<br><br>Teikiame pranešimą su prisijungimo nuoroda į 2026 m. gegužės 20 d. šaukiamą Sun Investment Group, UAB obligacijų savininkų susirinkimą, kuris vyks nuotoliniu būdu, per Zoom platformą.<br><br><a href=\"https://us06web.zoom.us/j/82706444217?pwd=qhb0eJoUC1b3ZJMvYrDOY2dqzMGFsl.1\" target=\"_blank\">Tiesioginė prisijungimo nuoroda čia</a> arba nuėjus į <a href=\"https://zoom.us/join\" target=\"_blank\">https://zoom.us/join</a>.<br>Susirinkimo <b>ID: 827 0644 4217</b><br><b>Slaptažodis: UpU40D</b><br><br>Išsami informacija apie organizuojamą susitikimą ir susijusius dokumentus buvo paskelbta 2026 m. balandžio 24 d. (<a href=\"https://view.news.eu.nasdaq.com/view?id=1436879&lang=lt\" target=\"_blank\">Dėl šaukiamo Sun Investment Group, UAB obligacijų savininkų susirinkimo</a>).<br><br>Nasdaq nuoroda: <a href=\"https://view.news.eu.nasdaq.com/view?id=1439599&lang=lt\" target=\"_blank\">Dėl prisijungimo nuorodos į nuotolinį Sun Investment Group, UAB obligacijų savininkų susirinkimą</a>"
    ]
  }
}
</i18n>
